var FcFilterTypeOutlinedSelectModule = /** @class */ (function () {
    function FcFilterTypeOutlinedSelectModule() {
    }
    return FcFilterTypeOutlinedSelectModule;
}());
export { FcFilterTypeOutlinedSelectModule };
